/* Núvo — research-use / terms agreement gate.
   Disables the Checkout button + accelerated checkout buttons (Shop Pay / PayPal /
   G Pay) until the customer ticks the agreement checkbox. Works in the cart drawer
   and the /cart page, and re-applies after the cart re-renders. Consent is per
   page-load (resets on reload) but persists across cart re-renders so adding items
   doesn't un-tick it. Loaded globally; idle until an agreement checkbox appears. */
(function () {
  'use strict';
  if (window.__nuvoAgreeInit) return;
  window.__nuvoAgreeInit = true;

  var agreed = false;

  function apply() {
    var checks = document.querySelectorAll('[data-agree-check]');
    if (!checks.length) return; // no checkbox (empty cart) -> don't touch buttons
    var i;
    for (i = 0; i < checks.length; i++) checks[i].checked = agreed;

    var btns = document.querySelectorAll('button[name="checkout"]');
    for (i = 0; i < btns.length; i++) {
      if (agreed) {
        btns[i].removeAttribute('disabled');
        btns[i].removeAttribute('aria-disabled');
      } else {
        btns[i].setAttribute('disabled', '');
        btns[i].setAttribute('aria-disabled', 'true');
      }
    }

    var dyn = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
    for (i = 0; i < dyn.length; i++) dyn[i].classList.toggle('nuvo-agree-locked', !agreed);
  }

  function flash() {
    var labels = document.querySelectorAll('.nuvo-agree');
    for (var i = 0; i < labels.length; i++) {
      (function (el) {
        el.classList.add('nuvo-agree--flash');
        setTimeout(function () { el.classList.remove('nuvo-agree--flash'); }, 1200);
      })(labels[i]);
    }
  }

  document.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('[data-agree-check]');
    if (!c) return;
    agreed = !!c.checked;
    apply();
  });

  // Backup to pointer-events: block accelerated/checkout clicks until agreed.
  document.addEventListener(
    'click',
    function (e) {
      if (agreed) return;
      if (!document.querySelector('[data-agree-check]')) return;
      var t = e.target;
      if (!t.closest) return;
      var blocked =
        t.closest('.cart__dynamic-checkout-buttons') ||
        t.closest('.additional-checkout-buttons') ||
        t.closest('.shopify-payment-button') ||
        t.closest('button[name="checkout"]');
      if (blocked) {
        e.preventDefault();
        e.stopPropagation();
        flash();
      }
    },
    true
  );

  // Re-apply after cart re-renders (drawer/cart page inject fresh HTML; Shopify
  // injects the accelerated buttons asynchronously).
  var scheduled = false;
  var obs = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; apply(); });
  });

  function start() {
    apply();
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
